import { TextoAviso } from './moleculas/ElementosAvisos';
import HeaderAviso from './HeaderAviso';
import { Link } from 'react-router-dom';
import { ContenedorAviso, ContenidoAviso } from './moleculas/ContenedorAviso';

const Terminos = () => {
  return (
    <ContenedorAviso>
      <HeaderAviso
        titulo='Términos y condiciones'
        subtitulo='Últ. Revisión: 14/03/2024'
      />
      <ContenidoAviso>
        <TextoAviso>
          Los servicios ofrecidos por SERVICIOS FINANCIEROS PROGRESO S.A.,
          sociedad anónima constituida bajo las leyes de la República de Chile,
          Rol Único Tributario N° 90.146.000-0 (en adelante, “Progreso”), rigen
          únicamente para el territorio nacional de la República de Chile y
          están sujetos a la normativa chilena aplicable y a los términos y
          condiciones comerciales establecidas por Progreso, para cada servicio.
        </TextoAviso>
        <TextoAviso>
          Progreso a través de su plataforma digital llamada “Temba”,
          proporcionará las facilidades tecnológicas para que el Usuario pueda
          enviar su información, requerimientos y solicitudes, con la finalidad
          de que éstos puedan contratar los servicios que Progreso ofrece.
        </TextoAviso>
        <TextoAviso fontWeight={'semibold'}>
          Mediante el envío del correspondiente formulario de registro, el
          Usuario reconoce, acepta, autoriza voluntaria y expresamente, a que la
          información que le es proporcionada a Progreso se integre a una base
          de datos personales de que se encontrará bajo la administración de
          Progreso. El Usuario autoriza y mandata en este acto para que Progreso
          conserve sus datos de forma confidencial, pero con la salvedad de que
          podrán ser utilizados solamente con fines estadísticos y para hacer
          llegar información al Usuario que podría ser de su interés, según la
          inscripción que por este acto realiza, y dentro de los límites de la
          legislación vigente.
        </TextoAviso>
        <TextoAviso>
          Los datos personales suministrados por los Usuarios no serán
          procesados de ninguna manera incompatible con los propósitos
          especificados inicialmente. En caso de requerirse información para
          propósitos distintos a los ya señalados, Progreso se comunicará con
          los Usuarios titulares de los datos personales respectivos, a objeto
          de obtener una nueva autorización al respecto. El tratamiento que
          haremos de los datos personales entregados por el Usuario, junto con
          los derechos que a este asisten en relación a la autorización que nos
          entrega para tratarlos, están regulados en la Política de Privacidad
          de Progreso, que se encuentra disponible para su acceso directo por
          medio de nuestro Sitio Web y en el siguiente enlace{' '}
          <TextoAviso
            as={Link}
            to={'https://www.progreso.cl/compania/politica-privacidad/'}
            target='_blank'
          >
            [
            <TextoAviso color={'bGreen.700'} as={'span'} fontWeight={'medium'}>
              https://www.progreso.cl/compania/politica-privacidad
            </TextoAviso>
            ]
          </TextoAviso>
          .
        </TextoAviso>
        <TextoAviso fontWeight={'semibold'}>
          El envío del presente formulario en ningún caso significa la
          contratación de los servicios que Progreso ofrece, los que en todo
          caso, se encontrarán sujetos a la respectiva aprobación comercial de
          Progreso, así como a la suscripción por parte del Usuario de los
          Términos y Condiciones y Contratos que regule cada uno de los
          servicios ofrecidos, conforme a las Políticas de Progreso que se
          encuentren vigentes al momento de contratar el servicio respectivo.
        </TextoAviso>
      </ContenidoAviso>
    </ContenedorAviso>
  );
};

export default Terminos;
